import { MantineThemeOverride } from '@mantine/core';

export type DialogTheme = NonNullable<MantineThemeOverride['components']>['Dialog'];

export const Dialog: DialogTheme = {
  // todo: define
};
